<template>
  <div class="content">
    <card>
      <div class="row">
        <ArtistSelect
          class="col-md-4"
          @memberChangeEvent="getArtistInfo"
          :show-members="false"
          :is-filter="true"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        />
        <div class="col-md-2">
          <h4 class="card-title text-left">상태</h4>
          <div class="row">
            <el-select @change="getStanningLogs(1)" class="select-primary" size="large" placeholder="선택" v-model="deleted">
              <el-option v-for="option in options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">&nbsp;</h4>
          <base-input placeholder="검색단어" v-model="searchKeyword">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <base-button @click="getStanningLogs(1)" type="default">검색</base-button>
        </div>
      </div>
    </card>
    <div class="row">
      <div class="col-sm-3" v-for="(item, index) in stanningLogs">
        <card class="card">
          <div class="row">
            <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.title" />
            <img v-else src="@/assets/img/blip-logo.png" />
          </div>
          <p class="card-text">{{ item.id }}: {{ item.categoryName }}</p>
          <p class="card-text">{{ item.title.length > 10 ? `${item.title.substring(0, 10)}...` : item.title }}</p>
          <p class="card-text">
            <a @click="goToUserDetail(item.userId)">{{ item.nickname }}</a>
          </p>
          <p class="card-text">({{ item.userId }})</p>
          <p class="card-text">{{ item.regTime }}</p>
          <base-button @click="goStanningDetail(item.id)" type="default">상세</base-button>
          <base-button @click="deleteStanningLog(item.id)" type="default">삭제</base-button>
        </card>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { BaseButton, BasePagination, Card, BaseInput } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import ArtistSelect from "@/pages/Components/ArtistSelect";
import { Alert } from "@/util/Alert";
import { StanningLogCategories } from "@/pages/MyPage/StanningLogCategories";

export default {
  components: {
    Card,
    BaseButton,
    ArtistSelect,
    BasePagination,
    BaseInput,
  },
  data() {
    return {
      deleted: 0,
      stanningLogs: [],
      currentPage: 1,
      totalPages: null,
      searchKeyword: null,
      options: [
        { label: "표시", value: 0 },
        { label: "삭제", value: 1 },
      ],
      types: StanningLogCategories,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getStanningLogs(this.currentPage);
      },
    },
  },
  methods: {
    async getStanningLogs(page) {
      return this.$axios
        .get(`/stanningLogs`, { params: { currentPage: page, unitId: this.unitId, deleted: this.deleted, searchKeyword: this.searchKeyword } })
        .then((res) => {
          this.stanningLogs = res.data.data.data.map((stanningLog) => {
            const imageIds = stanningLog.imageIds.split(",").filter((id) => id !== "");
            stanningLog.imageFileUrl = imageIds.length > 0 ? window.Endpoints.imageServerUrl + imageIds[0] : null;
            stanningLog.regTime = formatDateTime(stanningLog.regTime);
            stanningLog.categoryName = this.types
              .map((type) => {
                if (type.type === stanningLog.category) {
                  return type.name;
                } else {
                  return null;
                }
              })
              .filter((type) => type !== null)
              .toString();
            return stanningLog;
          });
          this.totalPages = Number(res.data.data.page);
        });
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getStanningLogs(1);
    },
    goToUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
    async deleteStanningLog(id) {
      if (await Alert.dangerousConfirmCancel("삭제 확인", `삭제 하시겠습니까?`)) {
        return this.$axios.delete(`/stanningLogs/${id}`).then((res) => {
          Toast.success("삭제 되었습니다");
          this.getStanningLogs(1);
        });
      }
    },

    goStanningDetail(id) {
      this.$router.push(`/myPage/stanningLogDetail?unitId=${this.unitId}&stanningLogId=${id}`);
    },
  },
};
</script>
<style></style>
